<div [formGroup]="form" fxLayout="column" fxLayoutGap="10px">
	<mat-form-field>
		<input
			autocomplete="email"
			matInput
			placeholder="Primary Email Address"
			formControlName="email"
		/>
		<mat-error *ngIf="form.get('email').hasError('email')">
			Invalid email address.
		</mat-error>
	</mat-form-field>
</div>
